<template>
  <div>
    <h1>Sign in</h1>
    
    <p><input type="text" placeholder="Email" v-model="email" /></p>
    <p><input type="password" placeholder="Password" v-model="password" /></p>
    
    <div id="error-reason-sign-in">{{ errorReason }}</div>
    <p>
      <button id="sign-in-button" class="button-large" @click="signIn()">
        Sign in
      </button>
    </p>
  </div>
</template>

<script>
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import store, { defaultNote } from '../store'
import { loadNotes } from '../firebase-helpers'

export default {
  data() {
    return {
      email: "",
      password: "",
      errorReason: "",
    }
  },

  methods: {
    signIn() {

      if (
        this.email === "" ||
        this.password === ""
      ) {
        console.log("either email or password is null");
        return;
      }

      const auth = getAuth();
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          store.commit("login", userCredential.user);
          loadNotes()
          store.commit("setActiveNote", { ...defaultNote })
          let el = document.getElementById('sign-in')
          el.style.display = 'none'
        })
        .catch((error) => {

          if (error.message.includes('auth/wrong-password')) {
            this.showErrorReason('Wrong password')
            return;
          }

          if (error.message.includes('auth/too-many-requests')) {
            this.showErrorReason('Access to this account has been temporarily disabled due too many failed login attempts. You can immediately restore it by resetting your password or you can try again later.')
            // TODO: add poosibility to reset password
            /*
              sendPasswordResetEmail(auth, email)
                .then(() => {
                  // Password reset email sent!
                  // ..
                })
                .catch((error) => {
                  const errorCode = error.code;
                  const errorMessage = error.message;
                  // ..
                });
            */
            return;
          }

          this.showErrorReason(error.message)
        });
    },

    showErrorReason(errorMessage) {
      this.errorReason = errorMessage;
      let el = document.getElementById("error-reason-sign-in");
      el.style.display = "block";
    }
    
  }


}
</script>

<style>
#sign-in-button {
  background-color: hsl(174, 72%, 76%);
}

#sign-in-button:hover {
  background-color: hsl(174, 72%, 56%);
}

#sign-in-button:active {
  background-color: hsl(174, 72%, 46%);
}

#error-reason-sign-in {
  display: none;
  color: var(--warning-text-color);
  background-color: var(--warning-background-color);
  border-radius: 10px;
  padding: 2px 5px;
}
</style>